<p-toast></p-toast>

<div *ngIf="parentInfo" class="grid mx-3">
  <div class="col-12">
    <p *ngIf="!parentInfo.parentDonorId"><b class="h4">Parent Donation</b></p>
    <p *ngIf="parentInfo.parentDonorId"><b class="h4">Child Donation</b></p>

    <!-- Parent Donation View -->
    <ng-container *ngIf="!parentInfo.parentDonorId">
      <p><b>Parent Donation Type:</b> {{ parentInfo.parentDonationType }}</p>
      <p *ngIf="parentInfo.paclimitNotAffected">
        <b>PAC Limit Not Affected:</b> Yes
      </p>
      <p *ngIf="!parentInfo.paclimitNotAffected">
        <b>PAC Limit Not Affected:</b> No
      </p>
    </ng-container>

    <!-- Child Donation View -->
    <ng-container *ngIf="parentInfo.parentDonorId">
      <p><b>Parent Donation Type:</b> {{ parentInfo.parentDonationType }}</p>
      <p><b>Parent Donation Name:</b> {{ parentInfo.parentDonor }}</p>
      <p><b>Parent Donation Number:</b> {{ parentInfo.parentDonationId }}</p>
    </ng-container>
  </div>
</div>

<!-- Edit Modal -->
<p-dialog 
  header="Edit Parent/Child Donation Info" 
  [(visible)]="isEditModalVisible" 
  [modal]="true" 
  [maximizable]="true" 
  draggable="false" 
  styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

  <div>
    <div ngClass="medium loader-wrapper" *ngIf="isEditDataLoading">
      <rc-loading-spinner></rc-loading-spinner>
    </div>

    <form [formGroup]="editForm" *ngIf="editForm && !isEditDataLoading">
      <p-card>
        <div class="formgrid grid">
          <!-- Parent/Child Selection -->
          <div class="field col-12 pt-3">
            <label>Select Donation Type</label>
            <div class="flex align-items-center mb-3 pt-2 gap-3">
              <p-radioButton name="selectedDonationType"
                            value="parent"
                            formControlName="selectedDonationType"
                            label="Parent">
              </p-radioButton>
              <p-radioButton name="selectedDonationType"
                            class="ml-2"
                            value="child"
                            formControlName="selectedDonationType"
                            label="Child">
              </p-radioButton>
            </div>
          </div>

          <!-- Parent Donation Type -->
          <div class="field col-12 md:col-6">
            <label>Parent Donation Type</label>
            <p-dropdown 
              formControlName="parentDonationTypeId" 
              [options]="parentDonationTypeOptions"
              optionLabel="text"
              optionValue="value"
              placeholder="Select Type">
            </p-dropdown>
            <small class="p-error" *ngIf="isInvalid('parentDonationType')">Parent Donation Type is required</small>
          </div>

          <!-- PAC Limit Not Affected Checkbox -->
          <div class="field-checkbox col-12 md:col-6" *ngIf="showPacLimitNotAffected">
            <p-checkbox formControlName="pacLimitNotAffected" binary="true"></p-checkbox>
            <label for="pacLimitNotAffected">PAC Limit Not Affected</label>
          </div>

          <!-- Conditional Fields for Child Donation -->
          <div class="field col-12 md:col-6" *ngIf="isChildDonation">
            <label>Parent Donation Name</label>
            <p-autoComplete 
              formControlName="parentDonorName" 
              [suggestions]="filteredParentDonationNames" 
              (completeMethod)="filterParentDonationNames($event)"
              (onSelect)="onParentDonationNameSelect($event)">
            </p-autoComplete>
            <small class="p-error" *ngIf="isInvalid('parentDonorName')">Parent Donation Name is required</small>
          </div>

          <div class="field col-12 md:col-6" *ngIf="isChildDonation">
            <label>Parent Donation Number</label>
            <p-dropdown 
              formControlName="parentDonationId" 
              [options]="parentDonationNumberOptions" 
              placeholder="Select Number">
            </p-dropdown>
            <small class="p-error" *ngIf="isInvalid('parentDonationId')">Parent Donation Number is required</small>
          </div>
        </div>
      </p-card>
      <div class="imported-dialog-footer">
        <p-button label="Cancel" type="button" [text]="true" (click)="onEditCancel()"></p-button>
        <p-button label="Save" severity="primary" type="button" (click)="onEditSubmit()" [disabled]="isReadOnlyMode"></p-button>
      </div>
    </form>
  </div>
</p-dialog>
